/* eslint-disable */
import { mapGetters } from 'vuex'

let install = Vue => {
  if (install.installed) return
  Vue.mixin({
    methods: {
      hasPermission(resourceId) {
        try {
          let has = this.resourceList[resourceId]
          if (has && this.resourceList[resourceId].status!==0) {
            return true
          } else {
            return false
          }
        } catch (e) {}
      },
      // 手机号掩码 182******82
      phoneFormat: function(value) {
        if (value === undefined || value === '' || value === null) return value
        if (value) {
          return (
            value.substring(0, 3) + '*****' + value.substring(value.length - 4)
          )
        }
      },
      pxTorem(pxValue) {
        return pxValue / 12
      },
      // 邮箱掩码
      emailFormat(input) {
        var output = input
        if (input == null || input == '' || input === undefined) return output
        output = input.trim()
        var emailParts = input.split('@')
        if (emailParts.length > 1) {
          if (emailParts[0].length > 3)
            output =
              emailParts[0].substr(0, 2) +
              '***' +
              emailParts[0].substr(emailParts[0].length - 1)
          else if (emailParts[0].length > 0)
            output = emailParts[0].substr(0, 1) + '***'
          output += '@' + emailParts[1]
        }
        return output
      },
      isEmpty(val) {
        if (!!val) {
          return val
        }
        return 'N/A'
      },
      isEmptyData(val) {
        if (val === undefined || val === '' || val === null) {
          return true
        }
        return false
      }
    },
    computed: {
      ...mapGetters({
        resourceList: 'getResourceList',
        winInfo: 'getWinInfo'
      })
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/mixins/resourcePermission.js